// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"700f6d2d","667":"6e819588","977":"2368a198"}[chunkId] + ".chunk.js";
};